import DeviceBySiteModal from './devices-status-modal.connect'

export default DeviceBySiteModal
